'use client';

import { CredentialType } from '@/api/types';
import { Alert } from '@/components/Alert';
import { useSessionStore } from '@/store/session';
import { PropsWithChildren, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SocialAlert, SocialAlertsContext } from './SocialAlertsContext';

export const SocialSignInProvider = ({ children }: PropsWithChildren) => {
  const [alertType, setAlertType] = useState(SocialAlert.NONE);
  const clearAlert = () => setAlertType(SocialAlert.NONE);

  const { t } = useTranslation();
  const isGoogleOnlySignIn = useSessionStore(
    (s) =>
      s.allowedCredentials.length === 1 &&
      s.allowedCredentials[0] === CredentialType.SOCIAL_GOOGLE,
  );

  return (
    <SocialAlertsContext value={setAlertType}>
      <Alert
        data-testid="apple-error"
        isOpen={alertType === SocialAlert.APPLE}
        onCloseClick={clearAlert}
        alertBannerType="error"
      >
        {t('No apple')}
      </Alert>
      <Alert
        data-testid="google-error"
        isOpen={alertType === SocialAlert.GOOGLE}
        onCloseClick={clearAlert}
        alertBannerType="error"
      >
        {t(
          isGoogleOnlySignIn
            ? 'google unavailable try again later'
            : 'No google',
        )}
      </Alert>
      {children}
    </SocialAlertsContext>
  );
};
